/** Internal KPI / marketing analytics DTOs (`/v1/analytics/kpi`). */

const num = (v: any): number | null => (v != null ? Number(v) : null);

export function ChartSeries(data: Record<string, any> = {}) {
  return {
    name: data.name || '',
    data: (data.data || []).map((v: any) => (v == null ? null : num(v))),
    chart_type: data.chart_type || null,
    y_axis_index: data.y_axis_index ?? null,
  };
}

export function TimeSeriesChart(data: Record<string, any> = {}) {
  return {
    categories: data.categories || [],
    series: (data.series || []).map(ChartSeries),
  };
}

export function ComboChart(data: Record<string, any> = {}) {
  return {
    categories: data.categories || [],
    series: (data.series || []).map(ChartSeries),
    overlay_series: (data.overlay_series || []).map(ChartSeries),
  };
}

export function KPISummary(data: Record<string, any> = {}) {
  return {
    total_users: data.total_users || 0,
    new_users: data.new_users || 0,
    active_users: data.active_users || 0,
    total_jobs: data.total_jobs || 0,
    jobs_by_status: data.jobs_by_status || {},
    cash_collected_eur: num(data.cash_collected_eur) ?? 0,
    credits_consumed_eur: num(data.credits_consumed_eur) ?? 0,
    period_start: data.period_start || null,
    period_end: data.period_end || null,
  };
}

export function UmamiStats(data: Record<string, any> = {}) {
  return {
    pageviews: data.pageviews || 0,
    visitors: data.visitors || 0,
    visits: data.visits || 0,
    bounces: data.bounces || 0,
    total_time_s: data.total_time_s || 0,
    bounce_rate: data.bounce_rate != null ? Number(data.bounce_rate) : null,
  };
}

export function MetricBreakdownItem(data: Record<string, any> = {}) {
  return {
    label: data.label || '',
    value: data.value || 0,
  };
}

export function MarketingOverview(data: Record<string, any> = {}) {
  return {
    stats: UmamiStats(data.stats || {}),
    pageviews: TimeSeriesChart(data.pageviews || {}),
    top_referrers: (data.top_referrers || []).map(MetricBreakdownItem),
    top_countries: (data.top_countries || []).map(MetricBreakdownItem),
    top_pages: (data.top_pages || []).map(MetricBreakdownItem),
  };
}

export function FunnelRate(data: Record<string, any> = {}) {
  return {
    numerator: data.numerator || 0,
    denominator: data.denominator || 0,
    rate: data.rate != null ? Number(data.rate) : null,
    event: data.event || null,
    denominator_kind: data.denominator_kind || 'visits',
    filters: data.filters || {},
  };
}

export function AITrafficItem(data: Record<string, any> = {}) {
  return {
    engine: data.engine || '',
    domain: data.domain || '',
    visits: data.visits || 0,
  };
}

export function AITraffic(data: Record<string, any> = {}) {
  return {
    total_visits: data.total_visits || 0,
    ai_visits: data.ai_visits || 0,
    ai_share: data.ai_share != null ? Number(data.ai_share) : null,
    breakdown: (data.breakdown || []).map(AITrafficItem),
  };
}

export function StarHistory(data: Record<string, any> = {}) {
  return {
    chart: TimeSeriesChart(data.chart || {}),
    totals: data.totals || {},
  };
}

export function GitHubOrgStats(data: Record<string, any> = {}) {
  return {
    org: data.org || '',
    stars: data.stars || 0,
    forks: data.forks || 0,
    public_repos: data.public_repos || 0,
  };
}
